import React, { useContext, useEffect, useRef } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import MessageOverlay from '../MessageOverlay';
import { ACTIONS, StartFightContext } from '../StartFightContext';

export default function StripeForm({ clientSecret, formSubmitRef, onSuccess, onError }) {
  const msgRef = useRef(null);
  const stripe = useStripe();
  const elements = useElements();
  const startFightCtx = useContext(StartFightContext);
  const formRef = formSubmitRef || startFightCtx;

  const triggerError = () => {
    if (msgRef.current) {
      msgRef.current.present();
    }
  };

  useEffect(() => {
    if (!stripe) {
      return;
    }

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          break;
        case 'processing':
          break;
        case 'requires_payment_method':
          console.warn('Your payment was not successful, please try again.');
          break;
        default:
          console.error('Something went wrong.');
          break;
      }
    });
  }, [stripe, clientSecret]);

  const handlePaymentElementChange = event => {
    startFightCtx.setPaymentComplete?.(event.complete);
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error('something went wrong while submitting Stripe Form');
      return;
    }

    const { paymentIntent, error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: 'http://localhost:3000',
      },
      redirect: 'if_required',
    });

    if (error) {
      console.error('Error occured while submitting Stripe Form: ', error);
      if (onError) {
        onError();
      }
      startFightCtx.dispatch({ action: ACTIONS.FAIL_SUBMIT });
      triggerError();
    } else {
      if (onSuccess) {
        onSuccess(paymentIntent);
      }
      startFightCtx.dispatch({
        action: 'setPayment',
        payment: paymentIntent.id,
      });
    }
  };

  const paymentElementOptions = {
    layout: 'tabs',
    defaultCollapsed: false,
    theme: 'stripe',
    variables: {
      colorPrimary: '#0570de',
      colorBackground: '#ffffff',
      colorText: '#30313d',
      colorDanger: '#df1b41',
      fontFamily: 'Ideal Sans, system-ui, sans-serif',
      spacingUnit: '2px',
      borderRadius: '4px',
    },
    fields: {
      billingDetails: 'auto',
      paymentMethod: 'auto',
      savePaymentMethod: 'auto',
    },
  };

  return (
    <div>
      <MessageOverlay
        ref={msgRef}
        msg='An error occured while processing the input card, please confirm that the details are correct'
        autoExit
        blur
        lifespan={5}
      />
      <form ref={formRef} id='payment-form' onSubmit={handleSubmit}>
        <PaymentElement id='payment-element' options={paymentElementOptions} onChange={handlePaymentElementChange} />
      </form>
    </div>
  );
}
